import React from 'react';
import Row from '../../../../../components/tag/Row';
import OTButton from '../../../../../components/tag/OTButton';
import { FormattedMessage } from 'react-intl';

let { id: module_id } = module;

const RemoveContactModalContent = ({ name, remove, closeModal }) => {
  return (
    <Row>
      <h4 className={'ot-modal__title'}>
        <FormattedMessage id={`${module_id}.title`} values={{ name }} />
      </h4>

      <Row style={{ textAlign: 'center' }}>
        <OTButton
          message={'cancel'}
          color={'gray'}
          onClick={() => {
            closeModal();
          }}
        />
        <OTButton
          message={'OK'}
          color={'darkBlue'}
          onClick={() => {
            remove();
            closeModal();
          }}
        />
      </Row>
    </Row>
  );
};

export default RemoveContactModalContent;
